export const N_DISPLAYED_SLOTS = 5;
